import type { PropsWithChildren, SyntheticEvent } from 'react';

/**
 * Wraps the body of a section of the Templates page, whose card folds on a click anywhere (#10841).
 * Without it, clicking a template card folds the section instead of doing nothing, so the body keeps
 * its own clicks. `contents` leaves the card grid inside untouched.
 */
export const NonCollapsingContent = ({ children }: PropsWithChildren) => {
    const keepClick = (event: SyntheticEvent) => event.stopPropagation();

    return (
        <div
            className={'contents'}
            onClick={keepClick}
        >
            {children}
        </div>
    );
};
